<template>
  <div>
    <h4 class="mdl-subheader">{{ trans('Select employer') }}</h4>

    <CompanySearch
      v-if="!hasCompanies"
      class="mt-4"
      :name-label="trans('Company')"
      v-model="registration.company"
      @input="errorMessage = null"
      @search="errorMessage = null"
    />

    <MunSelect
      v-else
      :placeholder="registration.company?.name"
      :options="compiledOptions"
      searchable
      @select="registration.company = $event"
    >
      <template #option-label="{ node, labelClassName }">
        <label :class="labelClassName">
          <div class="flex flex-col">
            <span>{{ node.label }}</span>
            <div class="opaque">
              {{ trans('Org.nr.') }} {{ node.raw.orgnr }}
              {{ flag(node.raw.country) }}
            </div>
          </div>
        </label>
      </template>
    </MunSelect>

    <div v-if="errorMessage" class="mdl-color-text--danger">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { trans } from '@/munio/i18n'
import CompanySearch from '@component/CompanySearch/index.vue'
import MunSelect from '@component/Select.vue'

import { find } from 'lodash'

export default {
  inject: ['registration'],

  components: {
    CompanySearch,
    MunSelect,
  },

  data() {
    return {
      errorMessage: null,
      search: null,
    }
  },

  computed: {
    employer() {
      return this.$store.state.employer
    },

    compiledOptions() {
      return this.optionNormalizer(this.$store.state.employerList)
    },

    hasCompanies() {
      return this.$store.state.employerList?.length > 0
    },
  },

  watch: {
    employer(employer) {
      // go to next page if user applied an invitation
      // with an employer while on the employer page
      if (employer) {
        this.errorMessage = null
        this.$parent.next()
      }
    },
  },

  methods: {
    trans,
    flag: window.Munio.flag,

    validate() {
      let isValid = true
      let { company } = this.registration
      this.errorMessage = null

      if (this.invite) return true

      if (!company) {
        this.errorMessage = trans('You must select an employer')
        return false
      }

      if (!this.hasCompanies) {
        if (!company.name) {
          this.errorMessage = trans('Company name is required')
          isValid = false
        }

        // the country selecter use company.company to hold
        // the orgnr for norwegian companies, while all other
        // countries use company.orgnr.....
        if (company.country === 'no') {
          if (!company.orgnr) {
            this.errorMessage = trans('Organization number is required')
            isValid = false
          }
        }
      }

      return isValid
    },

    optionNormalizer(employerList) {
      const options = []

      const root = find(employerList, ['id', this.$store.state.employerListRoot])

      options.push({
        id: root.id,
        label: root.name,
        ...root,
      })

      employerList.forEach((employer) => {
        if (employer.id !== root.id) {
          options.push({
            id: employer.id,
            label: employer.name,
            ...employer,
          })
        }
      })

      return options
    },
  },
}
</script>
